import { api } from 'services/api'

export async function updateUser(payload) {
  const { data } = await api.put('/users', payload)

  return data
}
